export default __webpack_public_path__ + "static/media/education-icon.9320e024.svg";